import { useEffect, useState } from "react";
import dayjs from 'dayjs';
import {toast} from "react-toastify";
import { alerta } from "components/Alert/index";
import http from "services/http";

// Dígitos do número por faixa da rifa. Dá para digitar menos: o número é completado
// com zero à esquerda antes de enviar.
const DIGITOS = { dezena: 2, centena: 3, milhar: 4, cem_mil: 5 };

export default function RifaResultado({location: dados}) {
  const [loading, setLoading] = useState(false);
  const [extracao, setExtracao] = useState({});
  const [resultados, setResultados] = useState([]);

  const digitos = DIGITOS[extracao.tipo] ?? 4;

  const mudarResultado = (jogo, numero) => {
		const arr = resultados.map((r) => r);
		if (numero.length <= digitos) {
			arr[jogo] = numero;
			setResultados(arr);
		}
	};

  const enviarResultado = async () => {

    if (!resultados[0]) {
      return toast.error('Informe o número sorteado')
    }

    await toast.promise(
      http.post('/rifas/resultado/'+extracao.id, {
        resultado: resultados.map((numero) => String(numero).padStart(digitos, '0'))
      }),
      {
        pending: {
          render(){
            setLoading(true)
            return 'Calculando resultado, aguarde!'
          }
        },
        success: {
          render({data}){
            setLoading(false)
            return data.data.message
          }
        },
        error: {
          render({data}){
            setLoading(false)
            alerta(data.response.data);
          }
        }
      }
    );
  }

  useEffect(() => {
    if (dados.extracao) {

      setExtracao(dados.extracao);
      setResultados(dados.extracao.resultado ? dados.extracao.resultado : []);

    }else{
      history.back();
    }
  }, []);

  return (
    <>
      <div className="titulo-principal">
				{extracao && extracao.nome} -&nbsp;
				{dayjs(extracao.data_limite).format('DD/MM/YYYY HH:mm')}
			</div>

      <div className="conteudo-principal">
        {extracao.forma_apuracao === 'federal' ? (
          <p className="text-muted">
            Esta rifa é apurada pela Loteria Federal: o resultado entra sozinho quando o
            resultado da extração {extracao.loteria?.nome} é lançado.
          </p>
        ) : (
          Array.from({ length: 1 }).map((_, index) =>
            <div key={index} className="form-group d-flex tres-colunas">
              <div style={{ width: '50px' }}>
                {index + 1}
              </div>
              <input
                type="number"
                className="form-control"
                placeholder={'0'.repeat(digitos)}
								onChange={(event) => mudarResultado(index, event.target.value)}
                value={resultados[index] || ''}
              />
              <div>{resultados[index]}</div>
            </div>
          )
        )}
        <div className="d-flex duas-colunas m-t">
          <button
            className="btn btn-secondary"
            onClick={() => history.back()}
            disabled={loading}
          >
            Voltar
          </button>
          {extracao.forma_apuracao !== 'federal' && (
            <button
              className="btn btn-primary"
              onClick={() => enviarResultado()}
              disabled={loading}
            >
              {!loading ? 'Salvar' : 'Aguarde...'}
            </button>
          )}
        </div>
      </div>
    </>
  )
}
